export const getImagePath = (image = "") => {
    return require(`@/assets/images/filter_banner_imgs/${image}`)
}